// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {SvgIconEl} from 'common/components/svg-icon';

import type {Checkbox} from './index';
import styles from './index.module.styl';

export function template(this: Checkbox) {
  const iconStyles = this.helpers.getIconStyles();
  return (
    <div sel={selx(styles.mpCheckboxWrapper)} class={this.helpers.getClasses()}>
      <div
        sel={selx(styles.mpCheckboxIcon, `item-icon`)}
        // HACK: for unknown reasons, when the component is re-rendered with new iconStyles, it's not updating the
        // inline styles here. Adding a key to force the element to be recreated fixes the issue.
        key={JSON.stringify(iconStyles)}
        style={iconStyles}
      >
        <div sel={selx(styles.mpCheckboxAnimationLayer)} />
        <SvgIconEl attrs={this.helpers.getIconAttributes()} />
      </div>
      {this.attr(`icon`) ? (
        <div sel={selx(styles.mpCheckboxAdditionalIcon)}>
          <SvgIconEl attrs={{icon: this.attr(`icon`)}} />
        </div>
      ) : null}
      <div sel={selx(styles.mpCheckboxLabel)}>
        <slot />
      </div>
    </div>
  );
}
